import { render, staticRenderFns } from "./BillingsList.vue?vue&type=template&id=aeec7002&scoped=true&"
import script from "./BillingsList.vue?vue&type=script&lang=js&"
export * from "./BillingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeec7002",
  null
  
)

export default component.exports